import React from 'react';
import {Route, Redirect} from 'react-router-dom';
import {connect} from 'react-redux';

const PrivateRoute = ({ component: Component, isAuthenticated, permissions, requires, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticated && permissions.find(p => p === requires) ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: !isAuthenticated ? '/login' : '/',
                        state: { from: props.location }
                    }}
                />
            )
        }
    />
);

function mapStateToProps(state) {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        roles: state.me.roles.map(r => r.name),
        permissions: state.me.permissions.map(p => p.name)
    };
}

export default connect(mapStateToProps)(PrivateRoute);


// WEBPACK FOOTER //
// ./resources/assets/js/components/PrivateRoute.js